import { useDynamicLocale } from '@/hoslog-intl';
import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { paymentLogsQueries } from '@/services/payment/payment.queries';
import { useRouterState } from '@tanstack/react-router';

export const useStorePaymentLogStoreName = (storeId: string) => {
  const { locale } = useDynamicLocale();
  const location = useRouterState({ select: (s) => s.location });
  const search = location.search as { storeName?: string; storeNameJp?: string } | undefined;
  const state = location.state as { storeName?: string; storeNameJp?: string } | undefined;

  const initialStoreName = search?.storeName || state?.storeName;
  const initialStoreNameJp = search?.storeNameJp || state?.storeNameJp;

  const shouldFetch = !initialStoreName && !initialStoreNameJp && !!storeId;
  const { data } = useQuery({
    ...paymentLogsQueries.list({ search: storeId }),
    enabled: shouldFetch,
  });

  const matchedStore = data?.data?.find((item) => item.clubId === storeId || item.id === storeId);

  const storeName = initialStoreName || matchedStore?.storeName || matchedStore?.storeInfo;
  const storeNameJp = initialStoreNameJp || matchedStore?.storeNameJp;

  const displayName = locale === 'en' ? storeName || storeNameJp || '' : storeNameJp || storeName || '';

  return {
    storeName,
    storeNameJp,
    displayName,
  };
};

export default useStorePaymentLogStoreName;
